/*
  DO NOT MODIFY THIS FILE
*/
import React from 'react'
import PropTypes from 'prop-types'

export const LoadingContext = React.createContext({
  isLoading: true,
})
